import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide05Benefits({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-123" data-mp="1sshp6w0mjmoe">
      <SlideHeader eyebrow="Proposed Campaign Model" data-id="element-124" data-mp="1sszs2bhskz5a">
        Each campaign becomes a short interactive journey
      </SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-6xl mx-auto w-full min-h-0" data-id="element-125" data-mp="1xq9i9td09eu6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="w-full flex-1 min-h-0 flex justify-center items-center pb-4" data-id="element-126" data-mp="1jv7dj9jw9viy">
          <img src="https://cdn.magicpatterns.com/uploads/8pJ9cD3w7mzFvc5zaeqAe3/Screenshot_2026-06-29_at_12.53.19.png" alt="GSK established brand example campaign flow" className="w-full max-w-5xl max-h-full object-contain rounded-2xl shadow-sm border border-black/5" data-id="element-127" data-mp="349ppp685gina" />
        </motion.div>
      </div>
    </InteriorSlide>;
}